<template>
  <vx-card v-show="isCardActiveLocal" title="Video Capture Task Details" class="mb-4">
    <div class="vx-row">
      <div class="vx-col w-full">
        <table>
          
          <tr><td><p>Module Name:</p></td><td><p style="font-weight: 700">{{ captureTask.moduleName }}</p></td></tr>
          <tr><td><p>Module Description:</p></td><td><p style="font-weight: 700">{{ captureTask.moduleDescription }}</p></td></tr>
          <tr><td><p>Task Display ID:</p></td><td><p style="font-weight: 700">{{ captureTask.taskDisplayId }}</p></td></tr>
          <tr><td><p>Task Name:</p></td><td><p style="font-weight: 700">{{ captureTask.taskName }}</p></td></tr>
          <tr> 
            <td><p>Student Fullname :&emsp;</p></td>  
            <td><p style="font-weight: 700">{{ ' ' + captureTask.fullname }}</p></td>
          </tr>
        </table>
      </div>
    </div>
    <vs-divider></vs-divider>
    <h5 class="mt-4 mb-3">Captured/Uploaded File</h5>
    <vs-table ref="uploadsTable" single max-items="15" @selected="open" pagination :data="this.captureTask.uploadedFiles">
      <div slot="header" class="mt-4 mb-3 flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">
        </div>
      </div>
      <template slot-scope="{data}">
        <vs-tr :data="file" :key="indextr" v-for="(file, indextr) in data">
          <vs-td>
            <img :src="setFileThumb(file)" width=30px class="product-img" />
          </vs-td>
          <vs-td>
            <p class="product-name font-medium">{{ file.substring(file.lastIndexOf('/') + 1) }}</p>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>
  export default {
    components: {
      
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      captureTask: {
        type: Object,
        required: false
      }
    },
    data() {
      return {
        captureTaskTitle: "",
        captureTaskDescription: ""
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeCard");
            this.initValues();
          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          if(self.captureTask){

          }else{
            self.initValues();
          }
        }
      }
    },
    methods: {
      strip(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
      },
      setColor(val) {
        if(val){
          return '#00cc00';
        }
        else{
          return 'orange';
        }
      },
      open(file){
        window.open(file);
      },
      saveData() {
        this.initValues();
        this.$emit('saveData');
      },
      initValues() {
        
        this.errors.clear();
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
      scrollToFooter() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -480,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("footerGlobal"), 100, scrollOptions);
      },
      setFileThumb(url) {
        var ext = url.substring(url.lastIndexOf('.') + 1);
        if (ext.includes('mp3'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/music.jpg";
        else if (ext.includes('jpg') || ext.includes('jpeg') || ext.includes('png') || ext.includes('gif'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/image.png";
        else if (ext.includes('doc') || ext.includes('xls') || ext.includes('pdf') || ext.includes('ppt') || ext.includes('txt') || ext.includes('rtf'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/document.png";
        else if (ext.includes('mp4') || ext.includes('wmv') || ext.includes('mov') || ext.includes('webm') || ext.includes('x-matroska') || ext.includes('mkv'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/video.png";
      },
    },
    mounted() {
      if(this.captureTask){
        this.captureTaskTitle = this.strip(this.captureTask.title);
        this.captureTaskDescription = this.strip(this.captureTask.description);
      }
    }
  }

</script>

<style lang="scss">
.table-class {
  border: solid;
  border-width: thin;
  border-color: rgb(248, 248, 248);
 }

.table-class:hover {
  transform: translate(0px, -3px);
}
</style>
